import { DateTime } from 'luxon'

function toDateTime(datetime) {
  if (datetime instanceof Date) {
    return DateTime.fromJSDate(datetime)
  } else if (typeof datetime === 'number') {
    return DateTime.fromMillis(datetime)
  } else {
    return DateTime.fromISO(datetime)
  }
}

const TimeAgoFormat = {
  install(app) {
    app.config.globalProperties.timeAgo = function(datetime, format = 'date.formats.default') {
      if (!datetime) {
        return ''
      }

      const parsed = toDateTime(datetime)

      if (!parsed.isValid) {
        return ''
      }

      const twoDaysAgo = DateTime.now().minus({ days: 2 })

      if (twoDaysAgo < parsed) {
        return parsed.setLocale(this.i18n.locale()).toRelative()
      } else {
        return this.i18n.l(format, datetime)
      }
    }
  }
}

export default TimeAgoFormat
